import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  closeCreateUserMappingUploadModal,
  createUserMappingUploadSelectedFileAction,
  createUserMappingUpload,
} from 'state/userMapping/actions';
import { Container, Header, Modal, Button, Form } from 'semantic-ui-react';

const CreateUserMappingUploadModal = props => {
  const {
    dispatch,
    createUserMappingUploadModal,
    createUserMappingUploadSelectedFile,
  } = props;

  const handleOnCancelButtonClick = () => {
    dispatch(closeCreateUserMappingUploadModal());
    dispatch(createUserMappingUploadSelectedFileAction(null));
  };

  const handleOnFileChange = e => {
    dispatch(createUserMappingUploadSelectedFileAction(e.target.files[0]));
  };

  const handleOnSaveButtonClick = () => {
    const payload = new FormData();
    payload.append('csv', createUserMappingUploadSelectedFile);
    dispatch(createUserMappingUpload(payload));
    dispatch(createUserMappingUploadSelectedFileAction(null));
    dispatch(closeCreateUserMappingUploadModal());
  };

  return (
    <Modal
      closeIcon
      as={Form}
      onSubmit={handleOnSaveButtonClick}
      open={createUserMappingUploadModal}
      onClose={handleOnCancelButtonClick}
      size="tiny"
    >
      <Header icon="users" content="Bulk Upload User Mapping" />
      <Modal.Content>
        <Container>
          <b>Mapping File (CSV) </b>
          <Button basic as="label" htmlFor="file" type="button" color="blue">
            Upload File
          </Button>
          <input type="file" id="file" hidden onChange={handleOnFileChange} />
          {createUserMappingUploadSelectedFile !== null ? (
            <span>{createUserMappingUploadSelectedFile.name}</span>
          ) : (
            <span>No file selected</span>
          )}
        </Container>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          type="button"
          color="blue"
          onClick={handleOnCancelButtonClick}
        >
          Cancel
        </Button>
        <Button type="submit" color="blue">
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ userMapping }) => ({
  createUserMappingUploadModal: userMapping.createUserMappingUploadModal,
  createUserMappingUploadSelectedFile:
    userMapping.createUserMappingUploadSelectedFile,
});

CreateUserMappingUploadModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  createUserMappingUploadModal: PropTypes.bool.isRequired,
  createUserMappingUploadSelectedFile: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(CreateUserMappingUploadModal);
